import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcAi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clip-path="url(#paint0_diamond_5814_1569_clip_path)"
      data-figma-skip-parse="true"
    >
      <g transform="matrix(-0.00875 0.00625 -0.00625 -0.00875 7.49999 7.49935)">
        <rect
          x="0"
          y="0"
          width="1264.87"
          height="1535.14"
          fill="url(#paint0_diamond_5814_1569)"
          opacity="1"
          shape-rendering="crispEdges"
        />
        <rect
          x="0"
          y="0"
          width="1264.87"
          height="1535.14"
          transform="scale(1 -1)"
          fill="url(#paint0_diamond_5814_1569)"
          opacity="1"
          shape-rendering="crispEdges"
        />
        <rect
          x="0"
          y="0"
          width="1264.87"
          height="1535.14"
          transform="scale(-1 1)"
          fill="url(#paint0_diamond_5814_1569)"
          opacity="1"
          shape-rendering="crispEdges"
        />
        <rect
          x="0"
          y="0"
          width="1264.87"
          height="1535.14"
          transform="scale(-1)"
          fill="url(#paint0_diamond_5814_1569)"
          opacity="1"
          shape-rendering="crispEdges"
        />
      </g>
    </g>
    <path
      d="M1.66666 5.66602C1.66666 3.45688 3.45752 1.66602 5.66666 1.66602H14.3333C16.5425 1.66602 18.3333 3.45688 18.3333 5.66602V14.3327C18.3333 16.5418 16.5425 18.3327 14.3333 18.3327H5.66666C3.45752 18.3327 1.66666 16.5418 1.66666 14.3327V5.66602Z"
      data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.11372549086809158,&#34;g&#34;:0.85882353782653809,&#34;b&#34;:0.85882353782653809,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.32156863808631897,&#34;b&#34;:0.93333333730697632,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.11372549086809158,&#34;g&#34;:0.85882353782653809,&#34;b&#34;:0.85882353782653809,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.32156863808631897,&#34;b&#34;:0.93333333730697632,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-17.50,&#34;m01&#34;:-12.499999046325684,&#34;m02&#34;:22.499988555908203,&#34;m10&#34;:12.499999046325684,&#34;m11&#34;:-17.50,&#34;m12&#34;:9.9993495941162109},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
    />
    <g clip-path="url(#clip0_5814_1569)">
      <path
        d="M10.3123 4.44531H13.1248V12.7786H10.3123V4.44531Z"
        fill="url(#paint1_linear_5814_1569)"
      />
      <path
        d="M15.9374 7.22266L15.9374 10.0004L7.49993 10.0004L7.49993 7.22266L15.9374 7.22266Z"
        fill="url(#paint2_linear_5814_1569)"
      />
      <rect
        x="15.9373"
        y="10"
        width="2.81248"
        height="8.33333"
        fill="url(#paint3_linear_5814_1569)"
      />
      <rect
        x="18.7501"
        y="12.7773"
        width="2.77778"
        height="5.62497"
        transform="rotate(90 18.7501 12.7773)"
        fill="url(#paint4_linear_5814_1569)"
      />
      <rect
        x="15.9373"
        y="1.66602"
        width="2.81248"
        height="5.55556"
        fill="url(#paint5_linear_5814_1569)"
      />
      <rect
        x="18.7501"
        y="1.66602"
        width="2.77778"
        height="5.62497"
        transform="rotate(90 18.7501 1.66602)"
        fill="url(#paint6_linear_5814_1569)"
      />
      <g
        clip-path="url(#paint7_diamond_5814_1569_clip_path)"
        data-figma-skip-parse="true"
      >
        <g transform="matrix(0.001093 0.0014542 -0.0014542 0.001093 7.5558 7.29089)">
          <rect
            x="0"
            y="0"
            width="1549.7"
            height="1549.7"
            fill="url(#paint7_diamond_5814_1569)"
            opacity="1"
            shape-rendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1549.7"
            height="1549.7"
            transform="scale(1 -1)"
            fill="url(#paint7_diamond_5814_1569)"
            opacity="1"
            shape-rendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1549.7"
            height="1549.7"
            transform="scale(-1 1)"
            fill="url(#paint7_diamond_5814_1569)"
            opacity="1"
            shape-rendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1549.7"
            height="1549.7"
            transform="scale(-1)"
            fill="url(#paint7_diamond_5814_1569)"
            opacity="1"
            shape-rendering="crispEdges"
          />
        </g>
      </g>
      <rect
        width="3.63832"
        height="3.63832"
        transform="translate(5.00861 6.92969) rotate(-36.9291)"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:2.1859986782073975,&#34;m01&#34;:-2.9083979129791260,&#34;m02&#34;:7.9170036315917969,&#34;m10&#34;:2.9083979129791260,&#34;m11&#34;:2.1859986782073975,&#34;m12&#34;:4.7436885833740234},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
      />
    </g>
    <defs>
      <clipPath id="paint0_diamond_5814_1569_clip_path">
        <path d="M1.66666 5.66602C1.66666 3.45688 3.45752 1.66602 5.66666 1.66602H14.3333C16.5425 1.66602 18.3333 3.45688 18.3333 5.66602V14.3327C18.3333 16.5418 16.5425 18.3327 14.3333 18.3327H5.66666C3.45752 18.3327 1.66666 16.5418 1.66666 14.3327V5.66602Z" />
      </clipPath>
      <clipPath id="paint7_diamond_5814_1569_clip_path">
        <rect
          width="3.63832"
          height="3.63832"
          transform="translate(5.00861 6.92969) rotate(-36.9291)"
        />
      </clipPath>
      <linearGradient
        id="paint0_diamond_5814_1569"
        x1="0"
        y1="0"
        x2="500"
        y2="500"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1DDBDB" />
        <stop offset="1" stop-color="#0052EE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5814_1569"
        x1="14.5832"
        y1="4.1676"
        x2="11.7186"
        y2="12.7786"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBD2FF" />
        <stop offset="1" stop-color="#EEF4FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5814_1569"
        x1="17.4999"
        y1="10.0004"
        x2="9.58321"
        y2="8.3337"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBD2FF" />
        <stop offset="1" stop-color="#EEF4FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5814_1569"
        x1="16.6665"
        y1="15.8333"
        x2="21.2498"
        y2="16.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EEF4FF" />
        <stop offset="1" stop-color="#88B1FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5814_1569"
        x1="20.139"
        y1="14.8607"
        x2="20.5557"
        y2="6.52734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EEF4FF" />
        <stop offset="1" stop-color="#88B1FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5814_1569"
        x1="22.9165"
        y1="3.74935"
        x2="17.3436"
        y2="7.22157"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#88B1FF" />
        <stop offset="1" stop-color="#EEF4FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5814_1569"
        x1="12.5001"
        y1="3.33268"
        x2="20.1389"
        y2="7.29098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#88B1FF" />
        <stop offset="1" stop-color="#EEF4FF" />
      </linearGradient>
      <linearGradient
        id="paint7_diamond_5814_1569"
        x1="0"
        y1="0"
        x2="500"
        y2="500"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_5814_1569">
        <path
          d="M1.66666 1.66602H14.3333C16.5425 1.66602 18.3333 3.45688 18.3333 5.66602V14.3327C18.3333 16.5418 16.5425 18.3327 14.3333 18.3327H1.66666V1.66602Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgIcAi;
